(() => {
  const TIERS = [2, 4, 6];
  const parsePieces = title => Math.max(2, Number.parseInt(String(title || '').match(/\d+/)?.[0] || '2', 10));
  const activeCurrency = () => window.Shopify?.currency?.active || 'EUR';
  const money = cents => {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('fr-FR', {style:'currency',currency:activeCurrency(),minimumFractionDigits:Number.isInteger(amount)?0:2,maximumFractionDigits:2}).format(amount);
    } catch(error) { return `${amount.toFixed(2).replace('.', ',')} €`; }
  };
  async function hydrate(){
    const ladder = document.querySelector('.aureko-bundle-ladder');
    if(!ladder) return;
    try {
      const response = await fetch('/products/wood-therapy-massage-set.js', {headers:{Accept:'application/json'}});
      if(!response.ok) return;
      const product = await response.json();
      TIERS.forEach(pieces => {
        const variant = product.variants?.find(v => parsePieces(v.title) === pieces);
        const card = ladder.querySelector(`.aureko-bundle-choice[href*="pieces=${pieces}"]`);
        if(!variant || !card) return;
        const price = card.querySelector('.aureko-bundle-choice__price');
        const perTool = card.querySelector('.aureko-bundle-choice__per');
        if(price) price.textContent = money(variant.price);
        if(perTool) perTool.textContent = `soit ${money(variant.price / pieces)} par outil`;
      });
    } catch(error) {}
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate, {once:true}); else hydrate();
})();
